import { render } from "./BaseRequiredCustomSelect.vue?vue&type=template&id=57712494"
import script from "./BaseRequiredCustomSelect.vue?vue&type=script&lang=js"
export * from "./BaseRequiredCustomSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__